/** Illustrative personalization delta (storefront Care Coordination / stage client 300). */
export const ILLUSTRATIVE_PERSONALIZATION_DELTA = {
  archetype: 'Pathfinder Developing',
  archetypeSlug: 'pathfinder/developing',
  activePriorities: [
    'Patient Access & Market Growth',
    'Digital Transformation & Data Strategy',
    'Financial Sustainability & Margin Improvement',
  ],
  relevanceTier: 'medium',
  intensityTier: 'critical',
  bvDelta: 9.5,
  easeDelta: -1.8,
  contractVersion: 'p4-delta-v1.0',
} as const;

export const ILLUSTRATIVE_PRIORITY_THEMES = [
  { slug: 'access_growth', label: 'Patient Access & Market Growth', activeInDelta: true },
  { slug: 'digital_transformation', label: 'Digital Transformation & Data Strategy', activeInDelta: true },
  { slug: 'financial_margin_improvement', label: 'Financial Sustainability & Margin Improvement', activeInDelta: true },
  { slug: 'patient_experience', label: 'Patient Experience', activeInDelta: false },
  { slug: 'population_health_vbc', label: 'Population Health & Value-Based Care', activeInDelta: false },
] as const;
